
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_8607_3256)"}},[_c('path',{attrs:{"d":"M23.854 23.854a.498.498 0 01-.708 0l-6.449-6.449A9.949 9.949 0 0110 20.001C4.486 20 0 15.514 0 10 0 4.486 4.486 0 10 0c2.247 0 4.369.728 6.139 2.105a.5.5 0 11-.615.789A8.908 8.908 0 0010.001 1C5.037 1 1 5.038 1 10c0 1.654.456 3.201 1.239 4.534l4.716-5.585a1.436 1.436 0 012.112-.089l2.07 2.07a.463.463 0 00.324.127.429.429 0 00.312-.149L21.123.172a.5.5 0 01.754.656l-9.348 10.737a1.433 1.433 0 01-2.098.073l-2.07-2.071a.423.423 0 00-.327-.127.431.431 0 00-.314.154l-4.892 5.815c1.644 2.175 4.242 3.59 7.173 3.59 4.963 0 9-4.038 9-9 0-.805-.105-1.602-.314-2.369a.5.5 0 01.965-.263c.232.852.35 1.737.35 2.631a9.949 9.949 0 01-2.596 6.697l6.449 6.449a.5.5 0 010 .707l-.001.003z","fill":"#000C1F"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_8607_3256"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    